import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';
import { getJson, getErrMsg } from '../service/serviceUtil';

import ContextualMessage from '../components/contextualMessage';
import UserDisplay from '../components/userDisplay';

class SendRecoveryCode extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            error: null,
            txtMsg: null,
            typeMsg: null,
            errorApi: false
        };
    }

    get labels() {
        return chainesLocales['SendRecoveryCode'][this.props.lang];
    }

    render() {
        const displaySubmitButton = (!this.state.errorApi && !this.state.error && !this.state.txtMsg && !this.state.typeMsg);

        return (
            <form className="text-left" onSubmit={this.onSubmit.bind(this)}>
                <h1>{this.labels.title}</h1>
                <UserDisplay user={this.props.user.username} lang={this.props.lang} />
                {displaySubmitButton ? <ContextualMessage type="info" showIcon={false} content={this.props.config[`MES_INFO_REINT_PASS_${this.props.lang}`]} /> : null}
                {
                    this.state.error ? <ContextualMessage type="error" content={getErrMsg(this.state.error, this.props.lang)} /> : null
                }
                {
                    this.state.txtMsg ? <ContextualMessage type={this.state.typeMsg} showIcon={false} content={this.state.txtMsg} /> : null
                }
                {
                    this.state.errorApi ? <ContextualMessage type="error" showIcon={false} content={chainesLocales['ErrApi'][this.props.lang].msg} /> : null
                }
                <div className="row">
                    <div className="col">
                        <div>
                            {displaySubmitButton ? <button className="btn btn-primary mr-3" type="submit"><span className="label">{this.labels.button}</span><span className="spinner"></span></button> : null}
                            <button className="btn btn-secondary" type="button"><span className="label" onClick={this.onRetourClick.bind(this)}>{this.labels.retourButton}</span><span className="spinner"></span></button>
                        </div>
                    </div>
                </div>
            </form>
        )
    }

    onRetourClick(e) {
        e.preventDefault();

        this.props.onPageSuccess({ sendRC: { newPage: "demande-mot-passe" }});
    }

    onSubmit(e) {
        e.preventDefault();
        
        if (document.querySelector) {
            document.querySelector('button[type="submit"]').disabled = true;
            if (document.body.classList) document.querySelector('button[type="submit"]').classList.add('loading');
        }

        let formData = new FormData();

        formData.append("lang", this.props.lang);
            
        let defaultParams = {
            lang: this.props.lang,
            suffixe: this.props.suffixe
        };

        let fetchOptions = {
            method: "POST",
            credentials: "same-origin",
            body: formData
        };

        getJson('sendRecoveryCode', defaultParams, fetchOptions).then(data => {
            if (data === true) {
                this.props.onPageSuccess({ sendRC: { newPage: "verif-recovery-code" }});
            } else {
                this.setState({ error: data.error, typeMsg: data.type, txtMsg: data.message, errorApi: ((!data.error && !data.message) ? true : false) });
            }
        }).catch(err => {
            console.error("Erreur API creer courriel: " + err);
    
            this.setState({ errorApi: true, error: null, typeMsg: null, txtMsg: null });
        });
    }
}

export default SendRecoveryCode;